import { useEffect, useMemo, useState } from 'react';
import CertificateShard from './CertificateShard.jsx';
import {
  ARCHIVIST_ACTIVE_WINDOW,
  ARCHIVIST_ROTATE_MS,
  allCertificateShards,
  archivistWindowShards
} from '../../p2p/scopes.js';

/**
 * Opt-in archivist coverage: rotates through every certificate shard so this
 * browser verifies and re-serves the full ladder corpus without holding 256
 * discovery rooms open at once.
 */
export default function ArchivistCoverage({
  node,
  identity,
  enabled = false,
  ownCertificateShard,
  peerShards = [],
  bootstrapPeerIds = [],
  onStored
}) {
  const allShards = useMemo(() => allCertificateShards(), []);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const timer = window.setInterval(() => {
      setOffset((current) => current + ARCHIVIST_ACTIVE_WINDOW);
    }, ARCHIVIST_ROTATE_MS);
    return () => window.clearInterval(timer);
  }, [enabled]);

  const activeShards = useMemo(() => {
    if (!enabled) {
      return [];
    }
    const windowShards = archivistWindowShards(allShards, offset);
    return [...new Set([
      ownCertificateShard,
      ...peerShards,
      ...windowShards
    ].filter((scope) => /^certs:[a-f0-9]{2}$/.test(scope)))].sort();
  }, [allShards, enabled, offset, ownCertificateShard, peerShards]);

  if (!enabled || !node) {
    return null;
  }

  return activeShards.map((shard) => (
    <CertificateShard
      key={shard}
      node={node}
      scope={shard}
      identity={identity}
      archivist={shard !== ownCertificateShard}
      bootstrapPeerIds={bootstrapPeerIds}
      onStored={onStored}
    />
  ));
}
